export const JavaHome = `query JavaHome($id: ID! = 1) {
  javaHome(id: $id) {
    FirstScreen {
        title
        url
        info
        contListDataes {
            title
            desc
            image{
              url
            }
            url
        }
        banner{
          url
        }
    }
    SecondScreen {
      title
      subTitle
      image{
        url
      }
    }
    ThirdScreen {
      title
      url
      info
      contListDataes{
        title
        subTitle
        desc
        image{
          url
        }
      }
    }
    fourthScreen{
      title
      BotTitle
      url
      info
      contListDataes{
        title
        image{
          url
        }
      }
    }
    fifthScreen{
      title
      url
      contListDataes{
        title
        url
      }
    }
    sixthScreen{
      title
      subTitle
      easeTree{
        title
        desc
        titleAndUrlImage{
          title
          url
          file{
            url
          }
        }
        icon{
          url
        }
      }
    }
    eighthScreen{
      title
      url
      info
      contListDataes{
        title
        subTitle
        desc
        url
        image{
          url
        }
        ButtonImage{
          url
        }
        ButtonHoverImage{
          url
        }
      }
    }
    ninthScreen{
      title
      url
      info
      contListDataes{
        title
        subTitle
        desc
        url
        image{
          url
        }
      }
    }
    objectLists{
      title
      url
      info
      isOpen
      BotTitle
      banner{
        url
      }
      contListDataes{
        title
        url
        image{
          url
        }
        ButtonImage{
          url
        }
      }
    }
    objectLists2{
      title
      desc
      url
      isShow
      labelA
      LableB
      lableList
      image{
        url
      }
      icon{
        url
      }
    }
    studentWorks{
      title
      subTitle
      desc
      url
      isShow
      labelA
      LableB
      lableList
      image{
        url
      }
      icon{
        url
      }
    }
  }
}`